/* *
 * The MIT License
 * 
 * Copyright (c) 2014, Sebastian Sdorra
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
'use strict';

angular.module('structures', ['adf'])
.config(function(dashboardProvider){
  
	dashboardProvider
	.structure('layout-a', {
		rows: [{
			columns: [{
				styleClass: 'col-xs-12 col-sm-12 col-md-12 col-lg-12'
			}]
		}]
	})
    .structure('layout-aa', {
    	rows: [{
    		columns: [{
    			styleClass: 'col-xs-6 col-sm-6 col-md-6 col-lg-6'
    		}, {
    			styleClass: 'col-xs-6 col-sm-6 col-md-6 col-lg-6'
    		}]
    	}]
    })
    .structure('layout-ba', {
    	rows: [{
    		columns: [{
    			styleClass: 'col-xs-4 col-sm-4 col-md-4 col-lg-4',
    			widgets: []
    		}, {
    			styleClass: 'col-xs-8 col-sm-8 col-md-8 col-lg-8',
    			widgets: []
    		}]
    	}]
    })
    .structure('layout-ab', {
    	rows: [{
    		columns: [{
    			styleClass: 'col-xs-8 col-sm-8 col-md-8 col-lg-8',
    			widgets: []
    		}, {
    			styleClass: 'col-xs-4 col-sm-4 col-md-4 col-lg-4',
    			widgets: []
    		}]
    	}]
    })
    .structure('layout-aaa', {
    	rows: [{
    		columns: [{
    			styleClass: 'col-md-4 col-sm-4 col-xs-4 col-lg-4',
    			widgets: []
    		}, {
    			styleClass: 'col-md-4 col-sm-4 col-xs-4 col-lg-4',
    			widgets: []
    		}, {
    			styleClass: 'col-md-4 col-sm-4 col-xs-4 col-lg-4',
    			widgets: []
    		}]
    	}]
    });
});


